module.exports = __webpack_public_path__ + "static/media/telling-their-stories.183ee514.png";